<template>
  <div>
    <section class="page-content">
      <div class="row">
        <div class="col-md-12">
          <form action @submit.prevent="next">
            <article class="input-section form-section d-flex flex-column">
              <label for class="orep-label">
                <span class="mr-1">16. </span>
                What is the experience of your programs?         </label>
              <div class="table-scroll">
                <table width="100%">
                  <thead>
                  <tr>
                    <th>
                      Company
                    </th>
                    <th>
                      Program
                    </th>
                    <th>
                      Loss Ratio Last Year
                    </th>
                    <th>
                      Loss Ratio 2nd Year Back
                    </th>
                    <th>
                      Loss Ratio 3rd Year Back
                    </th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <td>
                      <input
                          type="text"
                          class="orep-text-input"
                          name="experienceOfProgramCompany1"
                          @input="validateBeforeSubmit()"
                          v-model="mgaApplication.experienceOfProgramCompany1"
                      >
                    </td>
                    <td>
                      <input
                          type="text"
                          class="orep-text-input"
                          name="experienceOfProgramName1"
                          @input="validateBeforeSubmit()"
                          v-model="mgaApplication.experienceOfProgramName1"
                      >
                    </td>
                    <td>
                      <input
                          type="text"
                          class="orep-text-input"
                          name="experienceOfProgramLastYearRatio1"
                          @input="validateBeforeSubmit()"
                          v-model="mgaApplication.experienceOfProgramLastYearRatio1"
                      >
                    </td>
                    <td>
                      <input
                          type="text"
                          class="orep-text-input"
                          name="experienceOfProgram2YearRatio1"
                          @input="validateBeforeSubmit()"
                          v-model="mgaApplication.experienceOfProgram2YearRatio1"
                      >
                    </td>
                    <td>
                      <input
                          type="text"
                          class="orep-text-input"
                          name="experienceOfProgram3YearRatio1"
                          @input="validateBeforeSubmit()"
                          v-model="mgaApplication.experienceOfProgram3YearRatio1"
                      >
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <input
                          type="text"
                          class="orep-text-input"
                          name="experienceOfProgramCompany2"
                          @input="validateBeforeSubmit()"
                          v-model="mgaApplication.experienceOfProgramCompany2"
                      >
                    </td>
                    <td>
                      <input
                          type="text"
                          class="orep-text-input"
                          name="experienceOfProgramName2"
                          @input="validateBeforeSubmit()"
                          v-model="mgaApplication.experienceOfProgramName2"
                      >
                    </td>
                    <td>
                      <input
                          type="text"
                          class="orep-text-input"
                          name="experienceOfProgramLastYearRatio2"
                          @input="validateBeforeSubmit()"
                          v-model="mgaApplication.experienceOfProgramLastYearRatio2"
                      >
                    </td>
                    <td>
                      <input
                          type="text"
                          class="orep-text-input"
                          name="experienceOfProgram2YearRatio2"
                          @input="validateBeforeSubmit()"
                          v-model="mgaApplication.experienceOfProgram2YearRatio2"
                      >
                    </td>
                    <td>
                      <input
                          type="text"
                          class="orep-text-input"
                          name="experienceOfProgram3YearRatio2"
                          @input="validateBeforeSubmit()"
                          v-model="mgaApplication.experienceOfProgram3YearRatio2"
                      >
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <input
                          type="text"
                          class="orep-text-input"
                          name="experienceOfProgramCompany3"
                          @input="validateBeforeSubmit()"
                          v-model="mgaApplication.experienceOfProgramCompany3"
                      >
                    </td>
                    <td>
                      <input
                          type="text"
                          class="orep-text-input"
                          name="experienceOfProgramName3"
                          @input="validateBeforeSubmit()"
                          v-model="mgaApplication.experienceOfProgramName3"
                      >
                    </td>
                    <td>
                      <input
                          type="text"
                          class="orep-text-input"
                          name="experienceOfProgramLastYearRatio3"
                          @input="validateBeforeSubmit()"
                          v-model="mgaApplication.experienceOfProgramLastYearRatio3"
                      >
                    </td>
                    <td>
                      <input
                          type="text"
                          class="orep-text-input"
                          name="experienceOfProgram2YearRatio3"
                          @input="validateBeforeSubmit()"
                          v-model="mgaApplication.experienceOfProgram2YearRatio3"
                      >
                    </td>
                    <td>
                      <input
                          type="text"
                          class="orep-text-input"
                          name="experienceOfProgram3YearRatio3"
                          @input="validateBeforeSubmit()"
                          v-model="mgaApplication.experienceOfProgram3YearRatio3"
                      >
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <input
                          type="text"
                          class="orep-text-input"
                          name="experienceOfProgramCompany4"
                          @input="validateBeforeSubmit()"
                          v-model="mgaApplication.experienceOfProgramCompany4"
                      >
                    </td>
                    <td>
                      <input
                          type="text"
                          class="orep-text-input"
                          name="experienceOfProgramName4"
                          @input="validateBeforeSubmit()"
                          v-model="mgaApplication.experienceOfProgramName4"
                      >
                    </td>
                    <td>
                      <input
                          type="text"
                          class="orep-text-input"
                          name="experienceOfProgramLastYearRatio4"
                          @input="validateBeforeSubmit()"
                          v-model="mgaApplication.experienceOfProgramLastYearRatio4"
                      >
                    </td>
                    <td>
                      <input
                          type="text"
                          class="orep-text-input"
                          name="experienceOfProgram2YearRatio4"
                          @input="validateBeforeSubmit()"
                          v-model="mgaApplication.experienceOfProgram2YearRatio4"
                      >
                    </td>
                    <td>
                      <input
                          type="text"
                          class="orep-text-input"
                          name="experienceOfProgram3YearRatio4"
                          @input="validateBeforeSubmit()"
                          v-model="mgaApplication.experienceOfProgram3YearRatio4"
                      >
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </article>
            <article class="input-section form-section">
              <label for class="orep-label">
                <span class="mr-1">17. </span>Describe all of the functions you perform as a Wholesaler, MGA, MGU, or Program Adminstrator.
              </label>
              <input
                  type="text"
                  name="functionsYouPerformWholesaler"
                  v-model="mgaApplication.functionsYouPerformWholesaler"
                  class="orep-text-input w-100"
                  v-validate="'required'"
                  @input="validateBeforeSubmit()"
              >
              <span
                  v-show="errors.has('functionsYouPerformWholesaler')"
                  class="help is-danger form-errors text-danger"
              >{{ errors.first('functionsYouPerformWholesaler') | filterText }}</span>
            </article>
            <article class="input-section form-section d-flex flex-column">
              <div class="row">
                <div class="col-md-9 col-sm-12">
                  <label for class="orep-label">
                    <span class="mr-1">18. </span>
                    Have any programs been terminated in the last 5 years?
                  </label>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                            type="radio"
                            name="programTerminatedInFiveYears"
                            value="true"
                            class="orep-radio"
                            v-validate="'required'"
                            @change="validateBeforeSubmit()"
                            v-model="mgaApplication.programTerminatedInFiveYears"
                        >
                        <span class="radio-span">Yes</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                            type="radio"
                            name="programTerminatedInFiveYears"
                            value="false"
                            class="orep-radio"
                            v-validate="'required'"
                            @change="validateBeforeSubmit()"
                            v-model="mgaApplication.programTerminatedInFiveYears"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                  <span
                      v-show="errors.has('programTerminatedInFiveYears')"
                      class="help is-danger form-errors text-danger"
                  >{{ errors.first('programTerminatedInFiveYears') | filterText }}</span>
                </div>
              </div>
              <div class="col-md-auto d-flex flex-column" v-if="mgaApplication.programTerminatedInFiveYears == true || mgaApplication.programTerminatedInFiveYears === 'true'">
                <label class="orep-label text-danger">If yes, please describe the program, volume in the last year and reason for termination.
                </label>

                <input
                    type="text"
                    placeholder="Please Explain:"
                    class="orep-text-input js-orep-input"
                    v-if="mgaApplication.programTerminatedInFiveYears == true || mgaApplication.programTerminatedInFiveYears === 'true'"
                    name="programTerminatedInFiveYearsDetails"
                    v-model="mgaApplication.programTerminatedInFiveYearsDetails"
                >
              </div>
            </article>

            <article class="input-section form-section d-flex flex-column">
              <label for class="orep-label">
                <span class="mr-1">19. </span>
                List senior management of the applicant:         </label>
              <div class="table-scroll">
                <table width="100%">
                  <thead>
                  <tr>
                    <th>
                      Name
                    </th>
                    <th>
                      Title
                    </th>
                    <th>
                      Experience
                    </th>
                    <th>
                      % of Ownership
                    </th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <td>
                      <input
                          type="text"
                          class="orep-text-input"
                          name="seniorManagementName1"
                          @input="validateBeforeSubmit()"
                          v-model="mgaApplication.seniorManagementName1"
                      >
                    </td>
                    <td>
                      <input
                          type="text"
                          class="orep-text-input"
                          name="seniorManagementTitle1"
                          @input="validateBeforeSubmit()"
                          v-model="mgaApplication.seniorManagementTitle1"
                      >
                    </td>
                    <td>
                      <input
                          type="text"
                          class="orep-text-input"
                          name="seniorManagementExp1"
                          @input="validateBeforeSubmit()"
                          v-model="mgaApplication.seniorManagementExp1"
                      >
                    </td>
                    <td>
                      <input
                          type="text"
                          class="orep-text-input"
                          name="seniorManagementPercentageOwnership1"
                          @input="validateBeforeSubmit()"
                          v-model="mgaApplication.seniorManagementPercentageOwnership1"
                      >
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <input
                          type="text"
                          class="orep-text-input"
                          name="seniorManagementName2"
                          @input="validateBeforeSubmit()"
                          v-model="mgaApplication.seniorManagementName2"
                      >
                    </td>
                    <td>
                      <input
                          type="text"
                          class="orep-text-input"
                          name="seniorManagementTitle2"
                          @input="validateBeforeSubmit()"
                          v-model="mgaApplication.seniorManagementTitle2"
                      >
                    </td>
                    <td>
                      <input
                          type="text"
                          class="orep-text-input"
                          name="seniorManagementExp2"
                          @input="validateBeforeSubmit()"
                          v-model="mgaApplication.seniorManagementExp2"
                      >
                    </td>
                    <td>
                      <input
                          type="text"
                          class="orep-text-input"
                          name="seniorManagementPercentageOwnership2"
                          @input="validateBeforeSubmit()"
                          v-model="mgaApplication.seniorManagementPercentageOwnership2"
                      >
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <input
                          type="text"
                          class="orep-text-input"
                          name="seniorManagementName3"
                          @input="validateBeforeSubmit()"
                          v-model="mgaApplication.seniorManagementName3"
                      >
                    </td>
                    <td>
                      <input
                          type="text"
                          class="orep-text-input"
                          name="seniorManagementTitle3"
                          @input="validateBeforeSubmit()"
                          v-model="mgaApplication.seniorManagementTitle3"
                      >
                    </td>
                    <td>
                      <input
                          type="text"
                          class="orep-text-input"
                          name="seniorManagementExp3"
                          @input="validateBeforeSubmit()"
                          v-model="mgaApplication.seniorManagementExp3"
                      >
                    </td>
                    <td>
                      <input
                          type="text"
                          class="orep-text-input"
                          name="seniorManagementPercentageOwnership3"
                          @input="validateBeforeSubmit()"
                          v-model="mgaApplication.seniorManagementPercentageOwnership3"
                      >
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <input
                          type="text"
                          class="orep-text-input"
                          name="seniorManagementName4"
                          @input="validateBeforeSubmit()"
                          v-model="mgaApplication.seniorManagementName4"
                      >
                    </td>
                    <td>
                      <input
                          type="text"
                          class="orep-text-input"
                          name="seniorManagementTitle4"
                          @input="validateBeforeSubmit()"
                          v-model="mgaApplication.seniorManagementTitle4"
                      >
                    </td>
                    <td>
                      <input
                          type="text"
                          class="orep-text-input"
                          name="seniorManagementExp4"
                          @input="validateBeforeSubmit()"
                          v-model="mgaApplication.seniorManagementExp4"
                      >
                    </td>
                    <td>
                      <input
                          type="text"
                          class="orep-text-input"
                          name="seniorManagementPercentageOwnership4"
                          @input="validateBeforeSubmit()"
                          v-model="mgaApplication.seniorManagementPercentageOwnership4"
                      >
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </article>
            <article class="input-section form-section d-flex flex-column">
              <div class="row">
                <div class="col-md-9 col-sm-12">
                  <label for class="orep-label">
                    <span class="mr-1">20.</span>
                    Is the applicant licensed in all jurisdictions in which it transacts business for the classes of business transacted?
                  </label>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                            type="radio"
                            name="applicantLicensedInJurisdictions"
                            value="true"
                            class="orep-radio"
                            v-validate="'required'"
                            @change="validateBeforeSubmit()"
                            v-model="mgaApplication.applicantLicensedInJurisdictions"
                        >
                        <span class="radio-span">Yes</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                            type="radio"
                            name="applicantLicensedInJurisdictions"
                            value="false"
                            class="orep-radio"
                            v-validate="'required'"
                            @change="validateBeforeSubmit()"
                            v-model="mgaApplication.applicantLicensedInJurisdictions"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                  <span
                      v-show="errors.has('applicantLicensedInJurisdictions')"
                      class="help is-danger form-errors text-danger"
                  >{{ errors.first('applicantLicensedInJurisdictions') | filterText }}</span>
                </div>
              </div>
              <div class="col-md-auto d-flex flex-column" v-if="mgaApplication.applicantLicensedInJurisdictions == true || mgaApplication.applicantLicensedInJurisdictions === 'true'">
                <label class="orep-label text-danger">If yes, explain
                </label>

                <input
                    type="text"
                    placeholder="Please Explain:"
                    class="orep-text-input js-orep-input"
                    v-if="mgaApplication.applicantLicensedInJurisdictions == true || mgaApplication.applicantLicensedInJurisdictions === 'true'"
                    name="applicantLicensedInJurisdictionsDetails"
                    v-model="mgaApplication.applicantLicensedInJurisdictionsDetails"
                >
              </div>
            </article>

            <article class="input-section form-section">
              <label for class="orep-label">
                <span class="mr-1">21. </span>Insurance Operations:</label>
              <div class="row pb-3">
                <div class="col-md-6">
                  <label for class="orep-label mb-0 ml-1">
                    <span class="mr-1">a. </span>Number of policies issued per year:
                  </label>
                </div>
                <div class="col-md-4">
                  <input
                      type="text"
                      name="insuranceOperationsNumberOfPolicies"
                      v-model="mgaApplication.insuranceOperationsNumberOfPolicies"
                      class="orep-text-input w-100"
                  >
                </div>
              </div>
              <div class="row pb-3">
                <div class="col-md-6">
                  <label for class="orep-label mb-0 ml-1">
                    <span class="mr-1">b. </span>Number of currently contracted agents/ producers:
                  </label>
                </div>
                <div class="col-md-4">
                  <input
                      type="text"
                      name="insuranceOperationsNumberOfContracted"
                      v-model="mgaApplication.insuranceOperationsNumberOfContracted"
                      class="orep-text-input w-100"
                  >
                </div>
              </div>
              <div class="row pb-3">
                <div class="col-md-6">
                  <label for class="orep-label mb-0 ml-1">
                    <span class="mr-1">c. </span>Do contracted agents/ producers have binding authority:
                  </label>
                </div>
                <div class="d-flex col-md-4">
                  <div class="radio orep-radio-wrapper">
                    <label>
                      <input
                          type="radio"
                          name="insuranceOperationsAgentBindingAuthority"
                          id="insuranceOperationsAgentBindingAuthorityYes"
                          value="true"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="mgaApplication.insuranceOperationsAgentBindingAuthority"
                      >
                      <span class="radio-span">Yes</span>
                    </label>
                  </div>
                  <div class="radio orep-radio-wrapper">
                    <label>
                      <input
                          type="radio"
                          name="insuranceOperationsAgentBindingAuthority"
                          id="insuranceOperationsAgentBindingAuthorityNo"
                          value="false"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="mgaApplication.insuranceOperationsAgentBindingAuthority"
                      >
                      <span class="radio-span">No</span>
                    </label>
                  </div>
                </div>
              </div>
              <div class="row pb-3">
                <div class="col-md-6">
                  <label for class="orep-label mb-0 ml-1">
                    If yes, explain:
                  </label>
                <input
                    type="text"
                    placeholder="Please Explain:"
                    class="orep-text-input js-orep-input"
                    v-if="mgaApplication.insuranceOperationsAgentBindingAuthority == true || mgaApplication.insuranceOperationsAgentBindingAuthority === 'true'"
                    name="insuranceOperationsAgentBindingAuthorityDetails"
                    v-model="mgaApplication.insuranceOperationsAgentBindingAuthorityDetails"
                >
                </div>
              </div>

            </article>

            <article class="input-section form-section">
              <div class="row pb-3">
                <div class="col-md-8">
                  <label for class="orep-label mb-0 ml-1">
                    <span class="mr-1">22. </span> How frequently do your companies or reinsurers audit you?
                  </label>
                </div>
                <div class="col-md-4">
                  <input
                      type="text"
                      name="reinsurersAudit"
                      v-model="mgaApplication.reinsurersAudit"
                      class="orep-text-input w-100"
                  >
                </div>
              </div>
            </article>
            <article class="input-section form-section">
              <div class="row pb-3">
                <div class="col-md-8">
                  <label for class="orep-label mb-0 ml-1">
                    <span class="mr-1">23. </span> When was the last Audit completed?</label>
                </div>
                <div class="col-md-4">
                  <input
                      type="text"
                      name="lastAuditCompleted"
                      v-model="mgaApplication.lastAuditCompleted"
                      class="orep-text-input w-100"
                  >
                </div>
              </div>
            </article>

            <article class="input-section form-section d-flex flex-column">
              <div class="row">
                <div class="col-md-9 col-sm-12">
                  <label for class="orep-label">
                    <span class="mr-1">24. </span>
                    Do you assume risk on any program?
                  </label>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                            type="radio"
                            name="assumeRiskOnProgram"
                            value="true"
                            class="orep-radio"
                            v-validate="'required'"
                            @change="validateBeforeSubmit()"
                            v-model="mgaApplication.assumeRiskOnProgram"
                        >
                        <span class="radio-span">Yes</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                            type="radio"
                            name="assumeRiskOnProgram"
                            value="false"
                            class="orep-radio"
                            v-validate="'required'"
                            @change="validateBeforeSubmit()"
                            v-model="mgaApplication.assumeRiskOnProgram"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                  <span
                      v-show="errors.has('assumeRiskOnProgram')"
                      class="help is-danger form-errors text-danger"
                  >{{ errors.first('assumeRiskOnProgram') | filterText }}</span>
                </div>
              </div>
              <div class="col-md-auto d-flex flex-column" v-if="mgaApplication.assumeRiskOnProgram == true || mgaApplication.assumeRiskOnProgram === 'true'">
                <label class="orep-label text-danger">If yes, please explain:
                </label>

                <input
                    type="text"
                    placeholder="Please Explain:"
                    class="orep-text-input js-orep-input"
                    v-if="mgaApplication.assumeRiskOnProgram == true || mgaApplication.assumeRiskOnProgram === 'true'"
                    name="assumeRiskOnProgramDetails"
                    v-model="mgaApplication.assumeRiskOnProgramDetails"
                >
              </div>
            </article>
            <article class="input-section form-section d-flex flex-column">
              <div class="row">
                <div class="col-md-9 col-sm-12">
                  <label for class="orep-label">
                    <span class="mr-1">25. </span>
                    Do you have an electronic underwriting, billing, rating, quoting, binding, and policy issuance system?
                  </label>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                            type="radio"
                            name="haveElectronicPolicySystem"
                            value="true"
                            class="orep-radio"
                            v-validate="'required'"
                            @change="validateBeforeSubmit()"
                            v-model="mgaApplication.haveElectronicPolicySystem"
                        >
                        <span class="radio-span">Yes</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                            type="radio"
                            name="haveElectronicPolicySystem"
                            value="false"
                            class="orep-radio"
                            v-validate="'required'"
                            @change="validateBeforeSubmit()"
                            v-model="mgaApplication.haveElectronicPolicySystem"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                  <span
                      v-show="errors.has('haveElectronicPolicySystem')"
                      class="help is-danger form-errors text-danger"
                  >{{ errors.first('haveElectronicPolicySystem') | filterText }}</span>
                </div>
              </div>
              <div class="col-md-auto d-flex flex-column" v-if="mgaApplication.haveElectronicPolicySystem == true || mgaApplication.haveElectronicPolicySystem === 'true'">
                <label class="orep-label text-danger">If yes, please explain:
                </label>

                <input
                    type="text"
                    placeholder="Please Explain:"
                    class="orep-text-input js-orep-input"
                    v-if="mgaApplication.haveElectronicPolicySystem == true || mgaApplication.haveElectronicPolicySystem === 'true'"
                    name="haveElectronicPolicySystemDetails"
                    v-model="mgaApplication.haveElectronicPolicySystemDetails"
                >
              </div>
            </article>
            <article class="input-section form-section d-flex flex-column">
              <div class="row">
                <div class="col-md-9 col-sm-12">
                  <label for class="orep-label">
                    <span class="mr-1">26. </span>
                    Do you have authority to handle claims?
                  </label>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                            type="radio"
                            name="haveAuthorityToHandleClaims"
                            value="true"
                            class="orep-radio"
                            v-validate="'required'"
                            @change="validateBeforeSubmit()"
                            v-model="mgaApplication.haveAuthorityToHandleClaims"
                        >
                        <span class="radio-span">Yes</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                            type="radio"
                            name="haveAuthorityToHandleClaims"
                            value="false"
                            class="orep-radio"
                            v-validate="'required'"
                            @change="validateBeforeSubmit()"
                            v-model="mgaApplication.haveAuthorityToHandleClaims"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                  <span
                      v-show="errors.has('haveAuthorityToHandleClaims')"
                      class="help is-danger form-errors text-danger"
                  >{{ errors.first('haveAuthorityToHandleClaims') | filterText }}</span>
                </div>
              </div>
              <div class="col-md-auto d-flex flex-column" v-if="mgaApplication.haveAuthorityToHandleClaims == true || mgaApplication.haveAuthorityToHandleClaims === 'true'">
                <label class="orep-label text-danger">If yes, explain including authority.
                </label>

                <input
                    type="text"
                    placeholder="Please Explain:"
                    class="orep-text-input js-orep-input"
                    v-if="mgaApplication.haveAuthorityToHandleClaims == true || mgaApplication.haveAuthorityToHandleClaims === 'true'"
                    name="haveAuthorityToHandleClaimsDetails"
                    v-model="mgaApplication.haveAuthorityToHandleClaimsDetails"
                >
              </div>
            </article>

            <article class="input-section form-section d-flex flex-column">
              <div class="row">
                <div class="col-md-9 col-sm-12">
                  <label for class="orep-label">
                    <span class="mr-1">27. </span>
                    Do you have indemnification agreements with your companies for denial of coverage?
                  </label>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                            type="radio"
                            name="haveIndemnificationCoverage"
                            value="true"
                            class="orep-radio"
                            v-validate="'required'"
                            @change="validateBeforeSubmit()"
                            v-model="mgaApplication.haveIndemnificationCoverage"
                        >
                        <span class="radio-span">Yes</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                            type="radio"
                            name="haveIndemnificationCoverage"
                            value="false"
                            class="orep-radio"
                            v-validate="'required'"
                            @change="validateBeforeSubmit()"
                            v-model="mgaApplication.haveIndemnificationCoverage"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                  <span
                      v-show="errors.has('haveIndemnificationCoverage')"
                      class="help is-danger form-errors text-danger"
                  >{{ errors.first('haveIndemnificationCoverage') | filterText }}</span>
                </div>
              </div>
            </article>
            <article class="input-section form-section d-flex flex-column">
              <div class="row">
                <div class="col-md-9 col-sm-12">
                  <label for class="orep-label">
                    <span class="mr-1">28. </span>
                    Do you negotiate, place, or purchase reinsurance on behalf of any carriers?
                  </label>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                            type="radio"
                            name="purchaseReinsuranceBehalfCarriers"
                            value="true"
                            class="orep-radio"
                            v-validate="'required'"
                            @change="validateBeforeSubmit()"
                            v-model="mgaApplication.purchaseReinsuranceBehalfCarriers"
                        >
                        <span class="radio-span">Yes</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                            type="radio"
                            name="purchaseReinsuranceBehalfCarriers"
                            value="false"
                            class="orep-radio"
                            v-validate="'required'"
                            @change="validateBeforeSubmit()"
                            v-model="mgaApplication.purchaseReinsuranceBehalfCarriers"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                  <span
                      v-show="errors.has('purchaseReinsuranceBehalfCarriers')"
                      class="help is-danger form-errors text-danger"
                  >{{ errors.first('purchaseReinsuranceBehalfCarriers') | filterText }}</span>
                </div>
              </div>
              <div class="col-md-auto d-flex flex-column" v-if="mgaApplication.purchaseReinsuranceBehalfCarriers == true || mgaApplication.purchaseReinsuranceBehalfCarriers === 'true'">
                <label class="orep-label text-danger">If yes, please explain.
                </label>

                <input
                    type="text"
                    placeholder="Please Explain:"
                    class="orep-text-input js-orep-input"
                    v-if="mgaApplication.purchaseReinsuranceBehalfCarriers == true || mgaApplication.purchaseReinsuranceBehalfCarriers === 'true'"
                    name="purchaseReinsuranceBehalfCarriersDetails"
                    v-model="mgaApplication.purchaseReinsuranceBehalfCarriersDetails"
                >
              </div>
            </article>
          </form>
        </div>
      </div>
    </section>
    <div class="row">
      <div class="col-md-12">
        <section class="flex wrap bottom-section">
          <router-link :to="{name:'ibdpro-mga-application-1'}" class="next-btn back-btn flex mont spaced">
            <i class="fas fa-arrow-left"></i>
            Back
          </router-link>
          <article class="orep-pagination">
            <button class="pagination-dots" @click="navigateToOne()"></button>
            <button class="pagination-dots" @click="navigateToPrev('ibdpro-mga-application-2')"></button>
            <button class="pagination-dots" @click="navigateToPrev('ibdpro-mga-application-3')" :disabled="!state.pageThreeIsValid"></button>
            <span class="pagination-dots pagination-current"></span>
            <button class="pagination-dots" @click="navigateToNext('ibdpro-mga-application-5')" :disabled="!state.pageThreeIsValid || !state.pageFourIsValid"></button>
            <button class="pagination-dots" @click="navigateToNext('ibdpro-mga-application-6')" :disabled="!state.pageThreeIsValid || !state.pageFourIsValid || !state.pageFiveIsValid"></button>
            <button
                class="pagination-dots"
                @click="navigateToNext('ibdpro-mga-application-7')"
                :disabled="!state.pageOneIsValid || !state.pageTwoIsValid || !state.pageThreeIsValid || !state.pageFourIsValid || !state.pageFiveIsValid || !state.pageSixIsValid">
            </button>
          </article>
          <button type="submit" :disabled="!state.pageFourIsValid"
            :class="{submitDisabled: !state.pageFourIsValid}" class="next-btn mont spaced pull-right" @click="navigateToNext('ibdpro-mga-application-5')">Next</button>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import Datepicker from 'vuejs-datepicker';
import {APP_STATUS, STATES, STATUS} from "../../utils/constants";

var moment = require('moment')
export default {
  name: "ibdpro-mga-application-4",
  computedDates () {
    return moment(this.value).format('YYYY-MM-D')
  },
  computed: {
    mgaApplication() {
      return this.$store.state.mgaApplication.mgaApplication;
    },
    state() {
      return this.$store.state.mgaApplication;
    },
    errorMsg() {
      return this.$store.state.mgaApplication.errorMsg;
    },
  },
  watch: {
    errorMsg: {
      handler() {
        if (this.errorMsg) {
          this.$notify({
            group: 'error',
            type: 'error',
            text: this.errorMsg,
            duration: 15000
          });
        }
      }
    }
  },
  methods: {
    desiredCoverage(event) {
      if(!this.mgaApplication.desiredCoverage.find(coverage => coverage === event.target.value)) {
        if (this.mgaApplication.desiredCoverage.length < 1) {
          this.mgaApplication.desiredCoverage.push(event.target.value);
        } else {
          this.$notify({
            group: 'error',
            type: 'warning',
            title: 'Warning',
            text: 'You can select up to 1 coverages.'
          });
          event.target.checked = false
        }
      } else {
        this.mgaApplication.desiredCoverage = this.mgaApplication.desiredCoverage.filter(coverage => coverage !== event.target.value);
      }
    },
    navigateToOne() {
      this.$router.push({
        name: "ibdpro-mga-application-1"
      });
    },

    navigateToPrev(routeName) {
      this.$router.push({
        name: routeName
      });
    },
    navigateToNext(routeName) {
      this.$router.push({
        name: routeName
      });
    },

    validateBeforeSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.state.pageFourIsValid = true;
          return;
        }
        this.state.pageFourIsValid = false;
      });
    }
  },

  mounted() {
    $("html, body").animate(
      {
        scrollTop: $(".page-content").offset().top
      },
      500
    );
  },

  filters: {
    filterText(x) {
      if (x !== undefined) {
        if (x.indexOf("req") !== -1) {
          return "This field is required";
        } else {
          return x.replace("_", " ");
        }
      }
    }
  },
  components: {
    Datepicker
  }
};
</script>

<style scoped>
  table td, table th {
    border: 1px solid black;
  }
  table th {
    height: 35px;
  }
  table td, table th {
    text-align: center;
    max-width: 140px;
  }
  table input {
    width: 100%;
    text-align: center;
  }
</style>
